<template>
  <div class="evaluation" v-if="loaded">
    <p class="feedback" v-if="calculatedFeedback">
      {{ calculatedFeedback }}
    </p>
    <div class="accordions">
      <Accordion
        title="Bei folgenden Punkten haben Sie Schwierigkeiten bei der Umsetzung angegeben. Hier noch ein paar Tips, wie sie weiter vorgehen können."
        :open="accordionNotPossibleOpen"
        state="2"
        @stateChange="toggleNotPossibleOpen"
        v-if="itemsNotPossible.length"
        onlyActiveState
      >
        <div
          v-for="item in itemsNotPossible"
          :key="item.id"
          class="evaluationItem notPossible"
        >
          <span class="title">
            <b>{{ item.titleNotPossible }}</b>
          </span>
          <ul>
            <li v-for="(tip, index) in item.tips" :key="index">{{ tip }}</li>
          </ul>
        </div>
      </Accordion>

      <Accordion
        title="Folgende Punkte sollten Sie noch umsetzen. Fangen Sie am besten gleich an!"
        :open="accordionTodoOpen"
        @stateChange="toggleTodoOpen"
        state="1"
        v-if="itemsTodo.length"
        onlyActiveState
      >
        <div
          v-for="item in itemsTodo"
          :key="item.id"
          class="evaluationItem todo"
        >
          <span class="title"
            ><font-awesome-icon :icon="['far', 'circle']" class="icon" />{{
              item.titleTodo
            }}</span
          >
        </div>
      </Accordion>
    </div>
    <NavigationButton :to="{ path: '', query: { type: 'checklist', id } }">
      Zur Checkliste
    </NavigationButton>
  </div>
</template>

<script>
import { get, findLastIndex } from "lodash";
import Accordion from "@/components/Accordion.vue";
import NavigationButton from "@/components/NavigationButton.vue";

export default {
  name: "Evaluation",

  components: {
    Accordion,
    NavigationButton
  },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data: () => {
    return {
      accordionNotPossibleOpen: true,
      accordionTodoOpen: true,
      evaluationItems: {},
      merges: false,
      feedback: {},
      loaded: false
    };
  },

  computed: {
    internalId() {
      return `evaluation-checklist-${this.id}`;
    },
    checklistId() {
      return `checklist-${this.id}`;
    },
    itemsNotPossible() {
      return Object.entries(this.getChecklistStates(this.checklistId))
        .filter(state => state[1] === "2")
        .map(state => this.evaluationItems[state[0].split("/")[1]])
        .filter(_ => _);
    },
    itemsTodo() {
      return Object.entries(this.getChecklistStates(this.checklistId))
        .filter(state => state[1] === "1")
        .map(state => this.evaluationItems[state[0].split("/")[1]])
        .filter(_ => _);
    },
    itemsDone() {
      return Object.entries(this.getChecklistStates(this.checklistId))
        .filter(state => state[1] === "0")
        .map(state => this.evaluationItems[state[0].split("/")[1]])
        .filter(_ => _);
    },
    allItems() {
      return Object.entries(this.getChecklistStates(this.checklistId))
        .map(state => this.evaluationItems[state[0].split("/")[1]])
        .filter(_ => _);
    },
    calculatedFeedback() {
      const keys = Object.keys(this.feedback);
      const percentage = (this.itemsDone.length / this.allItems.length) * 100;
      const feedbackKey = keys[findLastIndex(keys, key => percentage >= key)];

      return get(this.feedback, feedbackKey, "");
    }
  },

  mounted() {
    this.loadEvaluationItems();
  },

  methods: {
    toggleTodoOpen() {
      this.accordionTodoOpen = !this.accordionTodoOpen;
    },
    toggleNotPossibleOpen() {
      this.accordionNotPossibleOpen = !this.accordionNotPossibleOpen;
    },
    async loadEvaluationItems() {
      try {
        const response = await fetch(`../assets/${this.internalId}.json`);
        const { items, merges, feedback } = await response.json();

        this.merges = merges;
        this.evaluationItems = items;
        this.feedback = feedback;
        this.loaded = true;
      } catch (erorr) {
        // eslint-disable-next-line
        console.error(erorr);
      }
    },
    handleAccordionStateChange({ id, open }) {
      this.setAccordionState({
        checklistId: this.id,
        id,
        open
      });
      this.$forceUpdate();
    },
    handleItemStateChange({ id, state }) {
      this.setItemState({
        id: this.generateItemId(id),
        value: state
      });
      this.$forceUpdate();
    },
    isAccordionOpen(accordionId) {
      return this.$store.getters.isAccordionOpen(this.internalId, accordionId);
    },
    getItemState(accordionId) {
      return this.$store.getters.accordionState(
        this.generateItemId(accordionId)
      );
    },
    generateItemId(accordionId) {
      return `${this.id}/${accordionId}`;
    },
    getChecklistStates(checklistId) {
      if (this.merges) {
        const itemIds = Object.keys(this.evaluationItems);
        return this.$store.getters.checklistStatesByItemIds(itemIds);
      }

      return this.$store.getters.checklistStates(checklistId);
    }
  }
};
</script>

<style lang="scss" scoped>
.feedback {
  font-style: italic;
  text-align: left;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #4d4d4d;
}

.accordions {
  margin-bottom: 40px;
}

.evaluationItem.notPossible {
  .title {
    border-bottom: solid white 1px;
    width: 40rem;
    display: block;
    padding: 0rem 0.7rem 0.7rem 0.7rem;
    margin: 0rem 1rem 1rem 1rem;
  }
}

.evaluationItem.todo {
  .title {
    .icon {
      margin-right: 0.5rem;
    }
  }
}
</style>
